/**
 * Created by olga on 21.01.2026
 */

const DialogueViewVertical = cc.Node.extend({
    ctor: function (dialogue) {
        this._super();
        this.dialogue = dialogue;
        this.stage = 0;

        this._lastSpeakerRole = null;
        this._lastOrientation = "right";

        this.setAnchorPoint(0, 0.5);
        this.setLocalZOrder(1);

        this.generateContent();
        this.onResize();
    },

    screenClicked: function () {
        if (this.dividedStages[this.stage]) {
            this.updateStage();
        } else {
            this.dialogue.next();
        }
    },

    generateContent: function () {
        const styles = cleverapps.styles.DialogueViewVertical;
        this.dialogueContent = new cc.Node();
        this.dialogueContent.setAnchorPoint(0.5, 0.5);

        const content = this.content = new cleverapps.Layout([], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
        content.avoidNode = "DialogueView";

        this.dialogueContent.addChild(content);
        this.addChild(this.dialogueContent);
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();

        const styles = cleverapps.styles.DialogueViewVertical;
        const targetBlockHeight = this.dialogue.options && this.dialogue.options.targetBlockHeight;
        const topOffset = targetBlockHeight
            ? styles.targetBlock.margin + targetBlockHeight + styles.targetBlock.dy
            : styles.topOffset;
        const availableHeight = sceneSize.height - styles.bottomOffset - topOffset;

        while (this.content.children.length > 1 && this.content.height > availableHeight) {
            this.content.removeChild(this.content.children[0]);
            this.content.reshape();
        }

        this.setContentSize(sceneSize);
        this.setAlignment(styles.position);

        this.dialogueContent.setContentSize(sceneSize.width, Math.max(availableHeight, this.content.height));
        this.dialogueContent.setAlignment({ align: "center" }, { align: "bottom", dy: styles.bottomOffset });
        this.content.setAlignment({ align: "center" }, { align: "top" });
        this.content.stopAllActions();
    },

    onChangeStage: function (stageData, silent) {
        stageData = cleverapps.clone(stageData, true);
        this.dividedStages = this.divideStage(stageData);
        this.stage = 0;
        this.updateStage(silent);
    },

    updateStage: function (silent) {
        const styles = cleverapps.styles.DialogueViewVertical;

        const stageData = this.dividedStages[this.stage];
        this.stage++;

        stageData.person = Person.ParseOptions(stageData.person);
        stageData.personIndex = `${this.getPersonIndex(stageData)}`;
        const role = stageData.person.role;

        if (this._lastSpeakerRole === role) {
            stageData.orientation = this._lastOrientation;
        } else {
            stageData.orientation = (this._lastOrientation === "left") ? "right" : "left";
            this._lastSpeakerRole = role;
            this._lastOrientation = stageData.orientation;
        }
        const replica = this.createReplica(stageData, silent);

        const refChild = !silent && this.content.children.length > 0
            ? this.content.children[this.content.children.length - 1]
            : null;
        const prevWorldY = refChild ? refChild.convertToWorldSpace(cc.p(0, 0)).y : 0;

        this.content.addChild(replica);

        if (stageData.image && !styles.noStageImage) {
            const image = this.createImage(stageData.image, silent);
            this.content.addChild(image);
        }

        this.content.reshape();
        this.onResize();

        if (refChild) {
            const newWorldY = refChild.convertToWorldSpace(cc.p(0, 0)).y;
            const dy = prevWorldY - newWorldY;
            if (dy !== 0) {
                this.content.setPositionY(this.content.y + dy);
                this.content.runAction(new cc.MoveBy(0.3, cc.p(0, -dy)).easing(cc.easeOut(2)));
            }
        }
    },

    divideStage: function (stageData) {
        const minLen = 12;
        const optimalLen = 100;
        const text = Messages.get(stageData.text);

        if (text.length <= optimalLen) {
            stageData.text = text;
            return [stageData];
        }

        const goodStops = ["…", ".", "!", "?"];
        const parts = [];

        let current = "";

        for (let i = 0; i < text.length; i++) {
            const ch = text[i];
            current += ch;

            if (goodStops.includes(ch) && current.length >= minLen) {
                if (ch === "…") {
                    if (text[i + 2] && text[i + 2].toUpperCase() === text[i + 2]) {
                        parts.push(current);
                        current = "";
                    }
                } else if (ch === ".") {
                    if (!text[i + 1] || text[i + 1] !== ".") {
                        parts.push(current);
                        current = "";
                    }
                } else {
                    parts.push(current);
                    current = "";
                }
            }
        }

        if (current) {
            if (current.length >= minLen) {
                parts.push(current);
            } else {
                parts[parts.length - 1] += current;
            }
        }

        const optimalParts = [parts[0]];
        for (let i = 1; i < parts.length; i++) {
            if (optimalParts[optimalParts.length - 1].length + parts[i].length <= optimalLen) {
                optimalParts[optimalParts.length - 1] += parts[i];
            } else {
                optimalParts.push(parts[i]);
            }
        }

        return optimalParts.map((part, index) => {
            const s = cleverapps.clone(stageData, true);
            s.text = part;

            if (index !== optimalParts.length - 1) {
                delete s.image;
            }

            return s;
        });
    },

    restoreState: function () {
        for (let i = 0; i <= this.dialogue.stage; ++i) {
            this.onChangeStage(this.dialogue.data[i], true);
            while (this.dividedStages[this.stage]) {
                this.updateStage(true);
            }
        }
    },

    getPersonIndex: function (stageData) {
        const role = stageData.person.role;
        return cleverapps.styles.DialogueViewVertical.colorTypes[role] || 0;
    },

    createReplica: function (stageData, silent) {
        const styles = cleverapps.styles.DialogueViewVertical.replica;
        const personNode = this.personNode = this.createPerson(stageData);
        const textNode = this.textNode = this.createTextNode(stageData);
        this.createPersonTitle(stageData);
        const items = [personNode, textNode];

        if (stageData.orientation === "right") {
            textNode.setAnchorPoint(1, 0.5);
            items.reverse();
        } else {
            textNode.setAnchorPoint(0, 0.5);
        }

        if (styles.textOffsetY) {
            textNode.layoutOffset = { y: styles.textOffsetY };
        }

        const layout = new cleverapps.Layout(items, {
            margin: styles.margin,
            direction: cleverapps.UI.HORIZONTAL
        });

        if (!silent) {
            personNode.setVisible(false);
            personNode.runAction(StandartAnimations.showUp(personNode));
            this.bubbleShowUp(textNode);
        }

        return layout;
    },

    bubbleShowUp: function (node) {
        node.setScale(0.46);
        node.setVisible(false);
        node.runAction(new cc.Sequence(
            new cc.DelayTime(0.2),
            new cc.Show(),
            new cc.CallFunc(() => {
                cleverapps.effects.fire("ui.dialogue.next.vertical");
            }),
            new cc.ScaleTo(0.2, 1).easing(cc.easeBackOut())
        ));
    },

    createPerson: function (stageData) {
        const person = stageData.person;

        const personNode = new cc.Node();
        personNode.setLocalZOrder(1);
        personNode.setAnchorPoint(0.5, 0.5);

        const personBackground = new cleverapps.Spine(bundles.vertical_dialogue.jsons.bg_portrait_json);
        personBackground.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        personNode.setContentSize2(personBackground.getContentSize());

        personBackground.setAnimation(0, "animation", true);
        personBackground.setSkin(stageData.personIndex);

        const json = cleverapps.persons.getVerticalDialogueJson(person.role);

        const personAnimation = new cleverapps.Spine(json);
        personAnimation.setAlignment({
            x: { align: "center" },
            y: { align: "center" }
        });

        let animationName = person.emotion;

        if (!personAnimation.hasAnimation(animationName)) {
            animationName = "idle";
        }

        personAnimation.setAnimation(0, animationName, true);

        if (stageData.orientation === "right") {
            personAnimation.setScaleX(-1);
        }

        personBackground.addChild(personAnimation);

        personNode.addChild(personBackground);

        if (stageData.orientation === "right") {
            personBackground.spine.setScaleX(-1);
        }

        return personNode;
    },

    createTextNode: function (stageData) {
        const textNode = new cc.Node();
        textNode.setAnchorPoint(0.5, 0.5);

        const styles = cleverapps.styles.DialogueViewVertical.text;
        const textBackground = new cleverapps.Spine(bundles.vertical_dialogue.jsons.bg_text_json);
        textBackground.setAnimation(0, "animation", true);
        
        if (textBackground.hasSkin(stageData.personIndex)) {
            textBackground.setSkin(stageData.personIndex);
        }

        textNode.addChild(textBackground, -1);
        cleverapps.UI.wrap(textNode);

        if (stageData.orientation === "right") {
            textBackground.setScaleX(-1);
        }

        const textWrapper = new cc.Node();
        textWrapper.setAnchorPoint(0.5, 0.5);
        textWrapper.setContentSize(styles.width, styles.height);
        textWrapper.setAlignment(stageData.orientation === "right" ? { align: styles.x.align, dx: -(styles.x.dx || 0) } : styles.x, styles.y);
        textNode.addChild(textWrapper);

        const text = cleverapps.UI.generateOnlyText(stageData.text, cleverapps.styles.FONTS[`DIALOGUE_VERTICAL_${stageData.personIndex}`] || cleverapps.styles.FONTS.DIALOGUE_VERTICAL);
        text.setDimensions(styles.width, 0);
        text.fitTo(undefined, styles.height);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        text.setAlignment({ align: "center" }, { align: "center" });
        textWrapper.addChild(text);

        return textNode;
    },

    createPersonTitle: function (stageData) {
        const styles = cleverapps.styles.DialogueViewVertical.title;
        const role = stageData.person.role;
        let key = `Dialogue.person.${role}`;

        if (!Messages.has(key)) {
            if (cleverapps.config.debugMode) {
                console.error(`person has no name! ${key} is missing in localization`);
            }
            key = "Dialogue.person.noName";
        }

        let title = cleverapps.UI.generateOnlyText(Messages.get(key), cleverapps.styles.FONTS[`DIALOGUE_VERTICAL_TITLE_${stageData.personIndex}`] || cleverapps.styles.FONTS.DIALOGUE_VERTICAL_TITLE);
        title.setDimensions(styles.width, 0);
        title.fitTo(undefined, styles.height);
        title.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        if (styles.backGround) {
            const titleBackground = new cleverapps.Spine(bundles.vertical_dialogue.jsons.bg_title_json);
            titleBackground.setAnimation(0, "animation", true);
            titleBackground.addChild(title);
            title.setAlignment(styles.backGround.text);

            if (stageData.orientation === "right") {
                titleBackground.setScaleX(-1);
                title.setScaleX(-1);
            }

            title = titleBackground;
        }

        title.setAlignment(styles);

        if (styles.parent === "person") {
            this.personNode.addChild(title);
            cleverapps.UI.wrap(this.personNode);
        } else {
            this.textNode.addChild(title);
        }
    },

    createImage: function (asset, silent) {
        const styles = cleverapps.styles.DialogueViewVertical.image;

        const bundle = bundles[this.dialogue.imageBundle];
        let image;
        if (bundle.frames[asset]) {
            image = new cc.Sprite(bundle.frames[asset]);
        } else if (bundle.jsons[asset]) {
            image = new cleverapps.Spine(bundles[this.dialogue.imageBundle].jsons[asset]);
            image.setAnimation(0, "animation", false);
        }
        image.setAlignment({ align: "center" }, { align: "center" });

        if (bundles.dialogues.frames.dialogue_image_bg_png) {
            this.image = cleverapps.UI.createScale9Sprite(bundles.dialogues.frames.dialogue_image_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        } else {
            this.image = new cc.Node();
            this.image.setAnchorPoint(0.5, 0.5);
        }
        this.image.addChild(image);
        this.image.setContentSize(image.width + styles.padding * 2, image.height + styles.padding * 2);

        cleverapps.UI.fitToBox(this.image, {
            width: styles.width,
            height: styles.height
        });

        if (!silent) {
            image.setVisible(false);
            cleverapps.effects.fire("ui.dialogue.picture");
            image.runAction(StandartAnimations.showUp(image));
        }

        return this.image;
    },

    showUp: function () {
        this.dialogueContent.setVisible(true);
    },

    onClose: function (silent, f) {
        this.content.stopAllActions();
        f();
    }

});

DialogueViewVertical.orientations = ["left", "right"];

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    DIALOGUE_VERTICAL_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    DIALOGUE_VERTICAL: {
        size: 34,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    }
});

cleverapps.styles.DialogueViewVertical = {
    colorTypes: {
        hero: 0
    },
    margin: 50,
    topOffset: 120,
    targetBlock: {
        dy: 60,
        margin: 50
    },
    bottomOffset: 100,

    position: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 }
    },

    replica: {
        margin: 30
    },

    text: {
        width: 390,
        height: 130,
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 28 }
    },

    title: {
        width: 300,
        height: 50,
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 17 }
    },

    image: {
        padding: 30,
        width: 660,
        height: 400
    }
};
